/**
 * Common IANA zones for the region this product serves. The field is a datalist
 * rather than a closed select: any valid zone is accepted, and the API falls
 * back to the city's country when the field is left blank.
 */
export const TIMEZONES = [
  "Asia/Riyadh",
  "Asia/Dubai",
  "Asia/Qatar",
  "Asia/Kuwait",
  "Asia/Bahrain",
  "Asia/Muscat",
  "Asia/Amman",
  "Asia/Beirut",
  "Asia/Baghdad",
  "Africa/Cairo",
  "Africa/Khartoum",
  "Africa/Tunis",
  "Africa/Algiers",
  "Africa/Casablanca",
  "UTC",
];
